import {createContext,JSX,useContext} from 'solid-js';
import { SetStoreFunction } from 'solid-js/store';
import { ITheme } from 'Shared/ITheme';
import { backendTheme as backendThemeFunc } from 'Shared/backend/Theme';
import { artistTheme as artistThemeFunc } from 'Shared/artists/Theme';
import Assert from 'Common/Assert';

/* Each wrap supplies its own theme type, so the setter can't be typed more precisely here */
type ThemeSetter = (...args:any[]) => void;

interface IThemeProvider {
	theme: ITheme;
	setTheme: ThemeSetter;
}

const ThemeContext = createContext<IThemeProvider>();

export function ThemeProvider(P:IThemeProvider & {children:JSX.Element}) 
{
	return (
		<ThemeContext.Provider value={P}>
			{P.children}
		</ThemeContext.Provider>
	);
}

function useThemeContext()
{
	return Assert.have(useContext(ThemeContext));
}

export function useSetTheme()
{
	return useThemeContext().setTheme as SetStoreFunction<ReturnType<typeof backendThemeFunc>>;
}

////////////// \\\\\\\\\\\\\\

export function sharedTheme():ITheme
{
	return useThemeContext().theme;
}

export function artistTheme(): ReturnType<typeof artistThemeFunc>
{
	return useThemeContext().theme as ReturnType<typeof artistThemeFunc>;
}

/* This is for VENUES. XXX maybe rename to backendTheme() in time. */
export function theme(): ReturnType<typeof backendThemeFunc>
{
	return useThemeContext().theme as ReturnType<typeof backendThemeFunc>;
}
